
export class ImportanceType {

    static NOT_RELEVANT = "NOT_RELEVANT";
    static UNIMPORTANT = "UNIMPORTANT";
    static SOME_IMPORTANCE = "SOME_IMPORTANCE";
    static IMPORTANT = "IMPORTANT";
    static VERY_IMPORTANT = "VERY_IMPORTANT";
    static MATTER_OF_THE_HEART = "MATTER_OF_THE_HEART";
}